import PlataformApi from '@/services/plataformApi'
import EmpresaUtils from '@/core/utils/empresa-utils'
import LoginUtils from '@/core/utils/login-utils'
import Constants from '@/core/constants/constants'
import Router from "../router"

const User = {
  components: {
    PlataformApi
  },
  
  state: () => ({
    infoUser : LoginUtils.getUser(),
    emailForgotPassword : '',
    errorsPasswordResetSolicitation : null
  }),

  getters: {
    infoUser: state => {
      return state.infoUser
    },
    emailForgotPassword: state => {
      return state.emailForgotPassword
    },
    errorsPasswordResetSolicitation: state => {
      return state.errorsPasswordResetSolicitation
    }
  },

  mutations: {
    setInfoUser (state, infoUser) {
      LoginUtils.setUser({ id: infoUser.id, name: infoUser.name, email: infoUser.email, cpf: infoUser.cpf})
      state.infoUser = infoUser
    },
    setEmailForgotPassword (state, emailForgotPassword) {
      state.emailForgotPassword = emailForgotPassword
    },
    setErrorsPasswordResetSolicitation (state, errorsPasswordResetSolicitation) {
      state.errorsPasswordResetSolicitation = errorsPasswordResetSolicitation
    }
  },

  actions: {
    async getUser ({ commit } ) {
      try {
        
        await PlataformApi.pegaConfiguracaoWL(EmpresaUtils.pegaReferenciaEmpresa()).then(empresa => {
          commit('setConfigEmpresa', empresa)
          if (!empresa.semHeader == true) {
            commit('setHeaderState', Constants.LOADED)
          }
           if (empresa.semFooter == true) {
             commit('setFooterState', false)
           } else {
             commit('setFooterState', true)
           }
        })
        let response = await PlataformApi.getUser()
        if (response.user.email == process.env.VUE_APP_VISITOR_ACCOUNT) {
          if (LoginUtils.isPwa()) {
            Router.push({ name: 'login'})
          } else {
            localStorage.setItem('fromAgenda', true)
            window.location = '/login'
          }
        } else {
          commit('setInfoUser', response)
          // commit('setConfigEmpresa', Config.getConfigEmpresa(String(response.user.logadoPelaEmpresa.id)))
        }
      } catch(errors) {
        if (LoginUtils.isPwa()) {
          Router.push({ name: 'login'})
        } else {
          localStorage.setItem('fromAgenda', true)
          window.location = '/login'
        }
      }
      let response = await PlataformApi.getNotification()
      commit('setNotifications', response.notificacoes)
      commit('setNewNotification', response.notificacoes.nova_notificacao)
      commit('setHeaderState', Constants.LOADED)
    },
    async passwordResetSolicitation ({ commit, getters }) {
      commit('setErrorsPasswordResetSolicitation', null)

      try{
        await PlataformApi.passwordResetSolicitation(getters.emailForgotPassword)
      }catch(errors){
        if(errors?.response?.status && errors.response.status == 500){
          commit('setErrorsPasswordResetSolicitation', { api : 'Falha ao solicitar redefinição de senha'})
        }else if(errors?.response?.status && errors.response.status == 422){
          commit('setErrorsPasswordResetSolicitation', { validations : errors.response.data.errors})
        }else{
          commit('setErrorsPasswordResetSolicitation', { api : 'Sistema fora do ar'})
        }
      }
    }
  }
};

export default User;